import { EventParameters } from './ga4/deviceModeTypes';

/**
 * This function must be implemented as shown.  If you push an ordinary array instead
 * of an `arguments` object, it won't trigger the tracking!
 *
 * The overloads are defined at https://developers.google.com/tag-platform/gtagjs/reference
 */
function gtag(command: 'config', targetId: string, additionalConfigInfo?: EventParameters): void;
function gtag(
  command: 'get',
  target: string,
  fieldName: string,
  callback: (value: unknown) => void
): void;
function gtag(command: 'set', parameters: EventParameters): void;
function gtag(command: 'event', eventName: string, eventParameters: EventParameters): void;
function gtag(
  command: 'consent',
  consentArgument: 'default' | 'update',
  consentParameters: {
    ad_storage: 'granted' | 'denied';
    ad_user_data: 'granted' | 'denied';
    ad_personalization: 'granted' | 'denied';
    analytics_storage: 'granted' | 'denied';
    wait_for_update?: number;
  }
): void;
function gtag(command: 'js', date: Date): void;
function gtag() {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export const applyGTMConsentDefaults = () => {
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied'
  });
};

export const applyGTMConsentUpdate = (consentGranted: boolean) => {
  const consentValue = consentGranted ? 'granted' : 'denied';

  gtag('consent', 'update', {
    ad_storage: consentValue,
    ad_user_data: consentValue,
    ad_personalization: consentValue,
    analytics_storage: consentValue
  });
};
